"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SvgIcon = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
function SvgIcon(_a) {
    var { className = 'icon', icon } = _a, allProps = tslib_1.__rest(_a, ["className", "icon"]);
    return (React.createElement("svg", Object.assign({ className: className }, allProps),
        React.createElement("use", { xlinkHref: `#${icon}` })));
}
exports.SvgIcon = SvgIcon;
//# sourceMappingURL=SvgIcon.js.map